<template>
  <div>

    <b-form @submit="onSubmit" class="b-white p-5 rounded b-shadow">
      <p class="text-center h4 mb-3" style="color: #ed8f00 !important;">
        ¡Completa la información para continuar con la experiencia que te brinda kllaar.com!
      </p>
      <h4 class="font-blue">Capacitador</h4>
      <hr>

      <b-form-group class="p-1" v-if="exist_email==0">
        <label>Correo electrónico <b class="font-orange">*</b></label>
        <b-form-input v-model="form.email" type="email" required placeholder="Ingresa tu cuenta de correo">
        </b-form-input>
        <b-form-invalid-feedback :state="false" v-if="this.response.email">
          {{this.response.email[0]}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-3"  label-for="input-3">
        <label>¿Eres? <b class="font-orange">*</b></label>
        <b-form-select
            id="input-3"
            v-model="form.trinertype"
            :options="type"
            :state="this.response.trinertype"
            required
        ></b-form-select>
      </b-form-group>

      <div class="d-flex flex-wrap justify-content-between">

        <b-form-group class="col-md-12 col-lg-12 col-sm-12 p-1">
          <label>Nombre de la empresa <b class="font-orange">*</b></label>
          <b-form-input v-model="form.enterprise_name" type="text" required
                        placeholder="Ingresa el nombre de la empresa"></b-form-input>
          <b-form-invalid-feedback :state="false" v-if="this.response.empresa_name">
            {{this.response.empresa_name[0]}}
          </b-form-invalid-feedback>
        </b-form-group>

      </div>


      <b-form-group class="p-1">
        <label>Domicilio fiscal <b class="font-orange">*</b></label>
        <b-form-input type="text" v-model="form.tax_residence" required
                      placeholder="Ingresa tu domicilio fiscal"/>
      </b-form-group>

      <b-form-group class="p-1">
        <label>RFC <b class="font-orange">*</b></label>
        <b-form-input type="text" v-model="form.RFC" required placeholder="Ingresa tu RFC"></b-form-input>
      </b-form-group>

      <div class="__fileattach">
        <b-alert show variant="" class="b-gray-light">
          <h4 class="alert-heading font-blue">Antes, necesitamos sabes más de ti. <b class="font-orange">*</b></h4>
          <p>
            Para obtener una cuenta en kllaar.com, requerimos que, por favor envíes la documentación que te acredite (a
            ti y/o a tu empresa) para impartir los cursos que ofrecerás en nuestra plataforma.
            Recibirás nuestra respuesta vía correo electrónico en cuanto hayamos verificado tu información.
          </p>
          <hr>
          <label class="btn b-gray-light bh-cursor mt-2" v-b-tooltip.hover
                 title="Seleccionar un archivo de tu computadora">
            <i class="fas fa-check" v-show="form.filetrainer"></i>
            <i class="fas fa-paperclip" v-show="!form.filetrainer"></i>
            <span v-show="!form.filetrainer">Seleccionar Documento</span>
            <span v-show="form.filetrainer">{{fileName}}</span>
            <input type="file" hidden ref="file" @change="handleFileUpload">
          </label>
        </b-alert>

        <div class="text-danger pb-2" v-show="this.response.filetrainer">Asegurate de cargar un archivo</div>
      </div>

      <b-form-group label="Sitio Web ">
        <b-form-input type="text" v-model="form.sitio_web" placeholder="https://www.mysitioweb.com/"></b-form-input>
      </b-form-group>
      <b-form-group label="LinkedIn">
        <b-form-input type="text" v-model="form.url_linkedIn" placeholder="https://www.linkedin.com/"></b-form-input>
      </b-form-group>
      <b-form-group label="Facebook">
        <b-form-input type="text" v-model="form.url_facebook" placeholder="https://www.facebook.com/"></b-form-input>
      </b-form-group>


      <b-form-group>
        <label>¿Cómo te enteraste de Kllaar.com? <b class="font-orange">*</b></label>
        <b-form-select
            id="input-3"
            v-model="form.how"
            :options="como"
            required
        ></b-form-select>
      </b-form-group>

      <b-form-group label="" v-if="form.how == 'Otro'">
        <b-form-input type="text" required placeholder="¿Cómo te enteraste?"></b-form-input>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox-group v-model="form.notificaciones" id="checkboxes-4">
          <b-form-checkbox value="acepto">Deseo recibir comunicados, publicidad desarrollados por Kllaar.
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>

      <b-button type="submit" class="b-orange col-sm-12" :disabled="loading">
        <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
        Continuar
      </b-button>

    </b-form>

    <b-card class="mt-3" header="Form Data Result" v-if="this.$appDebug">
      <pre class="m-0">{{ form }}</pre>
    </b-card>

  </div>
</template>
<script>

export default {
  name: 'formTrainer',
  props:['exist_email'],
  data() {
    return {
      loading: false,
      como: [{text: 'Selecciona una opción', value: null}, 'Un amigo', 'Internet', 'Redes Sociales', 'Otro'],
      type: [
        {text: 'Selecciona una opción', value: null},
        {text: 'Empresa',value: 'enterprise'},
        {text: 'Persona Física | actividad empresarial', value: 'personal'}
      ],
      fileName: '',
      form: {
        filetrainer: null,
        account: 'trainer',
        name: '',
        lname: '',
        email: '',
        how: '',
        password: '',
        password_confirmation: '',
        trinertype: null,
        tax_residence: '',
        enterprise_name: null,
        url_facebook: '',
        url_linkedIn: '',
        sitio_web: '',
        RFC: '',
        notificaciones: []
      },
      response: {}
    }
  },
  methods: {
    handleFileUpload(e) {
      this.form.filetrainer = e.target.files[0]
      this.fileName = e.target.files[0].name
    },
    onSubmit (evt) {

      evt.preventDefault()
      let fd = new FormData()
      fd.append('filetrainer', this.form.filetrainer)
      fd.append('account', this.form.account)
      // fd.append('name', this.form.name)
      // fd.append('lname', this.form.lname)
      fd.append('email', this.form.email)
      fd.append('trinertype', this.form.trinertype)
      fd.append('enterprise_name', this.form.enterprise_name)
      fd.append('url_facebook', this.form.url_facebook)
      fd.append('tax_residence', this.form.tax_residence)
      fd.append('url_linkedIn', this.form.url_linkedIn)
      fd.append('sitio_web', this.form.sitio_web)
      fd.append('rfc', this.form.RFC)

      // fd.append('password', this.form.password)
      // fd.append('password_confirmation', this.form.password_confirmation)
      this.loading = true
      this.$bus.$emit('registerTrainer', fd)
    },
  },
  created() {
    this.$bus.$on('registerTrainerResponse', (data)=>{
      this.loading = false
      this.response = data
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/components/#pages/validate/pages/formTrainer.vue